# password/PasswordService
PasswordService = ($http) ->
  create: (params) ->
    $http.post('/api/users/password', params)
  update: (params) ->
    $http.put('/api/users/password', params)

PasswordService.$inject = [
  '$http'
]

module.exports = PasswordService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/password/password-service.coffee